export default __webpack_public_path__ + "images/TN.c798518.png";